import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import BGMIImg from "../../assets/event-images/bgmi.jpeg";

const freeFire = {
  image: BGMIImg,
  description:
    "Welcome to the thrilling near-future realm of BGMI, where every moment pulses with heart-pounding action and strategic intensity! In this adrenaline-fueled tactical shooter, you and your team will embark on a journey like no other, navigating through dynamic landscapes and engaging in high-stakes battles.",
  type: "Elite Event",
  eventName: "BGMI",
  dateTime: "Feb 26 / 27, 6PM-9PM",
  venue: "Online",
  rules: [
"For each team, only one (i.e., team captain) has to register.",
"Minimum level requirement: 30 (players below this level are not allowed).",
"Team Size: Up to 4 players per team.",
"Placement Points:",
"1st: 10 points",
"2nd: 9 points",
"3rd: 8 points",
"4th: 7 points",
"5th: 6 points",
"1-point for kill",
"Tie-breaker: If teams are tied, a TDM will decide the final ranking.",
"Event Schedule:",
"Day 1: Erangel, Miramar, Sanhok",
"Day 2: Erangel, Miramar, Sanhok",
"After all matches, points will be totaled and prizes awarded.",
"Teaming up is not allowed.",
"Cheating, exploiting bugs, or using third-party apps is strictly prohibited and will result in disqualification.",
"Team captains will be notified of any schedule changes.",
"If one member of the team violates the rules, the entire team will be disqualified.",
"Starting time: 8.00 PM",
],

  firstprize: 2000,
  secondprize: 1000,
  thirdprize: 0,
  contact: [
    {
      name: "Vendhan R",
      phoneNo: "9944478315",
    },
    {
      name: "Sharan Dharshan C",
      phoneNo: "7418163273",
    },

  ],
};

const FreeFire = () => {
  return (
    <SingleEventPage
      eventDetails={freeFire}
      formsLink={"https://docs.google.com/forms/d/e/1FAIpQLScqmF3z5EoH1voQLNCbMEu_pWc3YVLQIg6ULQ3FgpO35FSMPQ/viewform?usp=dialog"}
      noVenue={true}
    />
  );
};

export default FreeFire;
